module.exports = __webpack_public_path__ + "img/pr-43.57217418.png";